import { Component, OnInit, Input } from '@angular/core';
import { ReportSettings, OrientationEnum } from './models/reportsettings.model';
import { ObjectValue } from 'src/app/reports/models/object-value.model';
import { Report } from '../../report/models/report.model';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  animations: [
    trigger('expand-advanced', [
      state('default', style({
        height: '0px',
        opacity: 0
      })),
      state('expanded', style({
        height: '100%',
        opacity: 1
      })),
      transition('* <=> *', animate('200ms 0s ease-in-out'))
    ])
  ],
  selector: 'app-report-settings',
  templateUrl: './report-settings.component.html',
  styleUrls: ['./report-settings.component.scss']
})
export class ReportSettingsComponent implements OnInit {

  //#region Inputs

  @Input() settings: ReportSettings;

  @Input() report: Report;

  //#endregion

  //#region Properties

  orientationsOptions = new Array<ObjectValue>();

  isGroupBy: boolean;

  advancedExpanded = true;

  //#endregion

  //#region Ctor

  constructor() { }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
    this.orientationsOptions = this.getOrientationList();

    this.settings.PageSize = 20;
    this.settings.PageSizeDetail = 20;
    this.settings.Orientation = OrientationEnum.Portrait;

    this.isGroupBy = this.getGroupColumnsCount() > 0;
  }

  //#endregion

  getOrientationList(): Array<ObjectValue> {
    const list: Array<ObjectValue> = [];

    list.push(new ObjectValue('Retrato', OrientationEnum.Portrait));
    list.push(new ObjectValue('Paisagem', OrientationEnum.Landscape));

    return list;
  }

  getGroupColumnsCount(): number {
    const columns = this.report.Entities.map(x => x.Columns);
    let count = 0;

    columns.forEach(column => {
      count += column.filter(x => x.IsGroupBy).length;
    });

    return count;
  }
}
